import DesignerFooter from "components/designerFooter";
import DesignerHeader from "components/designerHeader";
import DesignerSidebar from "components/desingerSidebar";
import {
  AppBar,
  Box,
  Button,
  Card,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Step,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import React from "react";
import {
  calendarIcon,
  closeIcon,
  editIcon,
  nextIcon,
  prevIcon,
  prevIconDisabled,
  prevIconLight,
  radioCheckedIcon,
  radioIcon,
  saveIcon,
} from "assets/images";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const steps = [0, 1, 2];

function RadioCheckBoxIcon() {
  return <img src={radioIcon} alt="checkbox" />;
}
function RadioCheckedboxIcon() {
  return <img src={radioCheckedIcon} alt="checkbox" />;
}
function CalendarIcon() {
  return (
    <div className="calendar-icon">
      <img src={calendarIcon} alt="calendar" />
    </div>
  );
}

const DesignerSLPGoals: React.FC = () => {
  // Stepper state
  const [activeStep, setActiveStep] = React.useState(0);
  const handleBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };
  const handleNext = () => {
    setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
  };

  // SLP Conducted By State
  const [select1, setSelect1] = React.useState("");
  const handleSelect1Change = (event: SelectChangeEvent) => {
    setSelect1(event.target.value as string);
  };

  // Assess Goal Attainment State
  const [assess, setAssess] = React.useState(false);
  const handleAssess = () => setAssess(true);
  const handleAssessClose = () => setAssess(false);

  return (
    <div className="wrapper">
      <Box
        className="overlay"
        onClick={() => document.body.classList.toggle("sidebar-toggle")}
      />
      <DesignerHeader />
      <main>
        <DesignerSidebar />
        <div className="main-content">
          <Box className="content-header simple-header">
            <Typography variant="h2" className="heading">
              SLP Goals & Assessment
            </Typography>
            <Box sx={{ display: "flex", columnGap: "14px" }}>
              <Button
                variant="outlined"
                className="px-16"
                component={Link}
                to="/designer-student-profile-details"
              >
                Back
              </Button>
            </Box>
          </Box>
          <AppBar position="static" className="student-header inline-header">
            {activeStep !== steps.length && (
              <Toolbar
                disableGutters
                sx={{ flexWrap: "wrap" }}
                className="header-container-bottom"
              >
                {activeStep === 0 && (
                  <Typography variant="h3" className="header-subtitle">
                    Part 1 - Hopes, Goals and Ambitions
                  </Typography>
                )}
                {activeStep === 1 && (
                  <Typography variant="h3" className="header-subtitle">
                    Part 2 - Personal and Smart Goals
                  </Typography>
                )}
                {activeStep === 2 && (
                  <Typography variant="h3" className="header-subtitle">
                    Part 3 - Where to from Here?
                  </Typography>
                )}

                <Stepper activeStep={activeStep}>
                  {steps.map((index) => {
                    const stepProps: { completed?: boolean } = {};

                    return (
                      <Step key={index} {...stepProps}>
                        <StepLabel>{index + 1}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </Toolbar>
            )}
          </AppBar>
          <Box className="stepper-box">
            <Box className="stepper-inner-box">
              {activeStep === 0 && (
                <>
                  <Typography variant="body2" className="gray-text-sm">
                    Student Name
                  </Typography>
                  <Typography
                    variant="h4"
                    className="medium-text"
                    sx={{ pb: 2.5 }}
                  >
                    Jacquelin E. Bellido
                  </Typography>
                  <Typography variant="h4" className="medium-text">
                    Preliminary: This SLP`&apos;s details
                    <em style={{ color: "#EA2222" }}>*</em>
                  </Typography>
                  <Typography
                    variant="overline"
                    className="text-gray font-italic"
                  >
                    In general, these details do not need to be changed.
                  </Typography>

                  <Grid
                    container
                    columnSpacing={{ xs: "16px", lg: "20px", xl: "24px" }}
                  >
                    <Grid item xs={12} sm={6} lg={4}>
                      <FormControl fullWidth className="select">
                        <InputLabel id="course1-label">
                          SLP Conducted By
                        </InputLabel>
                        <Select value={select1} onChange={handleSelect1Change}>
                          <MenuItem value="Alex Li">Alex Li</MenuItem>
                          <MenuItem value="Leslie Alexander">
                            Leslie Alexander
                          </MenuItem>
                          <MenuItem value="Arlene McCoy">Arlene McCoy</MenuItem>
                          <MenuItem value="Dianne Russell">
                            Dianne Russell
                          </MenuItem>
                          <MenuItem value="Jerome Bell">Jerome Bell</MenuItem>
                          <MenuItem value="Floyd Miles">Floyd Miles</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        label="SLP Number"
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  <Typography
                    variant="h4"
                    className="medium-text"
                    sx={{ pt: 2.5, pb: 1.5 }}
                  >
                    Part 1: Hopes, Goal and Ambitions
                  </Typography>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className="gray-text-sm"
                        sx={{ pb: 1 }}
                      >
                        1&#41; Current Circumstances: Since you have been
                        attending the Recovery & Wellbeing College, what changes
                        have occured in your recovery/health and wellbeing?
                      </Typography>
                      <TextField
                        multiline
                        fullWidth
                        variant="outlined"
                        rows={3}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className="gray-text-sm"
                        sx={{ pb: 1 }}
                      >
                        2&#41; Future Plans: What are your future plans and what
                        are you looking forward to?
                      </Typography>
                      <TextField
                        multiline
                        fullWidth
                        variant="outlined"
                        rows={3}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className="gray-text-sm"
                        sx={{ pb: 1 }}
                      >
                        3&#41; Recovery: How has your perspective on
                        recovery/health and wellbeing changed since your
                        involvement with the Recovery and Wellbeing College?
                        What courses are you interested in doing?
                      </Typography>
                      <TextField
                        multiline
                        fullWidth
                        variant="outlined"
                        rows={3}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className="gray-text-sm"
                        sx={{ pb: 1 }}
                      >
                        4&#41; Strengths: What are the Strengths and Attributes
                        that you know about yourself?
                      </Typography>
                      <TextField
                        multiline
                        fullWidth
                        variant="outlined"
                        rows={3}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className="gray-text-sm"
                        sx={{ pb: 1 }}
                      >
                        5&#41; Employment: If you set a goal to seek employment
                        have you received support for this? How did this go?
                      </Typography>
                      <TextField
                        multiline
                        fullWidth
                        variant="outlined"
                        rows={3}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
              {activeStep === 1 && (
                <>
                  <Typography
                    variant="h4"
                    className="medium-text"
                    sx={{ pb: 2.5 }}
                  >
                    SLP Goals
                  </Typography>
                  <TableContainer>
                    <Table className="table-h-md">
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" sx={{ width: "92px" }}>
                            Assessed
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              maxWidth: "84px",
                              width: "84px",
                              minWidth: "84px",
                            }}
                          >
                            SLP Number
                          </TableCell>
                          <TableCell sx={{ width: "120px", minWidth: "120px" }}>
                            Student Goal
                          </TableCell>
                          <TableCell sx={{ width: "200px", minWidth: "200px" }}>
                            Smart Goal
                          </TableCell>
                          <TableCell sx={{ width: "100px", minWidth: "100px" }}>
                            Importance
                          </TableCell>
                          <TableCell sx={{ width: "100px", minWidth: "100px" }}>
                            Difficulty
                          </TableCell>
                          <TableCell sx={{ width: "100px", minWidth: "100px" }}>
                            Goal Weight
                          </TableCell>
                          <TableCell sx={{ width: "100px" }}>
                            Baseline Level
                          </TableCell>
                          <TableCell sx={{ width: "130px", minWidth: "130px" }}>
                            Goal Achieved?
                          </TableCell>
                          <TableCell sx={{ width: "130px", minWidth: "130px" }}>
                            Achievement Ratings
                          </TableCell>
                          <TableCell sx={{ width: "100px", minWidth: "100px" }}>
                            Variance
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell align="center">
                            <div className="table-actions">
                              <IconButton onClick={handleAssess}>
                                <img src={editIcon} alt="Edit" />
                              </IconButton>
                            </div>
                          </TableCell>
                          <TableCell align="center">1</TableCell>
                          <TableCell>Prioritizing life goals</TableCell>
                          <TableCell>
                            Clarify my priorities, understand when to say no
                          </TableCell>
                          <TableCell>2</TableCell>
                          <TableCell>1</TableCell>
                          <TableCell>2</TableCell>
                          <TableCell>Ongoing</TableCell>
                          <TableCell>Unknown</TableCell>
                          <TableCell>3</TableCell>
                          <TableCell>N/A</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Typography variant="h6" sx={{ pt: 1.5, color: "#E54B4B" }}>
                    Note: If this is a &apos;Final SLP&apos;, Skip part 2, Below
                    - Do not add new goals
                  </Typography>
                  <Grid
                    container
                    sx={{ pt: 4 }}
                    columnSpacing={{ xs: 2, lg: 3, xl: "24px" }}
                  >
                    <Grid item xs={12} lg={6}>
                      <Typography
                        variant="h5"
                        className="medium-text"
                        sx={{ pb: 1.5 }}
                      >
                        Add Goals
                      </Typography>
                      <Grid container>
                        <Grid item xs={12}>
                          <Typography
                            variant="body2"
                            className="gray-text-sm"
                            sx={{ pb: 1 }}
                          >
                            Student Goal<em style={{ color: "#E54B4B" }}>*</em>
                          </Typography>
                          <TextField
                            multiline
                            fullWidth
                            variant="outlined"
                            rows={3}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Typography
                            variant="body2"
                            className="gray-text-sm"
                            sx={{ pb: 1 }}
                          >
                            Student Goal<em style={{ color: "#E54B4B" }}>*</em>
                          </Typography>
                          <TextField
                            multiline
                            fullWidth
                            variant="outlined"
                            rows={3}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Typography
                            variant="body2"
                            className="gray-text-sm"
                            sx={{ pb: 1 }}
                          >
                            Student Goal<em style={{ color: "#E54B4B" }}>*</em>
                          </Typography>
                          <TextField
                            multiline
                            fullWidth
                            variant="outlined"
                            rows={3}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            variant="body2"
                            className="gray-text-sm"
                            sx={{ pb: 1 }}
                          >
                            Importance<em style={{ color: "#E54B4B" }}>*</em>
                          </Typography>
                          <RadioGroup row>
                            <FormControlLabel
                              value="1"
                              control={
                                <Radio
                                  icon={<RadioCheckBoxIcon />}
                                  checkedIcon={<RadioCheckedboxIcon />}
                                />
                              }
                              label="1"
                            />
                            <FormControlLabel
                              value="2"
                              control={
                                <Radio
                                  icon={<RadioCheckBoxIcon />}
                                  checkedIcon={<RadioCheckedboxIcon />}
                                />
                              }
                              label="2"
                            />
                            <FormControlLabel
                              value="3"
                              control={
                                <Radio
                                  icon={<RadioCheckBoxIcon />}
                                  checkedIcon={<RadioCheckedboxIcon />}
                                />
                              }
                              label="3"
                            />
                          </RadioGroup>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            variant="body2"
                            className="gray-text-sm"
                            sx={{ pb: 1 }}
                          >
                            Difficulty<em style={{ color: "#E54B4B" }}>*</em>
                          </Typography>
                          <RadioGroup row>
                            <FormControlLabel
                              value="1"
                              control={
                                <Radio
                                  icon={<RadioCheckBoxIcon />}
                                  checkedIcon={<RadioCheckedboxIcon />}
                                />
                              }
                              label="1"
                            />
                            <FormControlLabel
                              value="2"
                              control={
                                <Radio
                                  icon={<RadioCheckBoxIcon />}
                                  checkedIcon={<RadioCheckedboxIcon />}
                                />
                              }
                              label="2"
                            />
                            <FormControlLabel
                              value="3"
                              control={
                                <Radio
                                  icon={<RadioCheckBoxIcon />}
                                  checkedIcon={<RadioCheckedboxIcon />}
                                />
                              }
                              label="3"
                            />
                          </RadioGroup>
                        </Grid>
                        <Grid item xs={12}>
                          <Button variant="contained" sx={{ mt: 3 }}>
                            Add Goal
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <Typography
                        variant="body2"
                        className="gray-text-sm"
                        sx={{
                          pb: 1.25,
                          pt: {
                            xs: 2,
                            lg: 0,
                          },
                        }}
                      >
                        <strong style={{ color: "#424242", fontWeight: 500 }}>
                          Note:
                        </strong>
                        Do not include a goal that is “not at all” important or
                        one that is “not at all” difficult
                      </Typography>

                      <TableContainer>
                        <Table className="cus-table">
                          <TableHead>
                            <TableRow>
                              <TableCell
                                align="center"
                                sx={{
                                  width: "10px",
                                  minWidth: "100px",
                                  maxWidth: "100px",
                                }}
                              >
                                Importance
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{
                                  width: "10px",
                                  minWidth: "100px",
                                  maxWidth: "100px",
                                }}
                              >
                                Difficulty
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell align="center" colSpan={2}>
                                Weight of goal = importance x Difficulty
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell align="left">
                                0 = not at all (important)
                              </TableCell>
                              <TableCell align="left">
                                10 = not at all (difficult)
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell align="left">
                                1 = a little (important)
                              </TableCell>
                              <TableCell align="left">
                                1 = a little (difficult)
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell align="left">
                                2 = moderately (important)
                              </TableCell>
                              <TableCell align="left">
                                2 = moderately (difficult)
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell align="left">
                                3 = very (important)
                              </TableCell>
                              <TableCell align="left">
                                3 = very (difficult)
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                    <Grid item xs={12}>
                      <Box sx={{ pt: { xs: 2, lg: 4 } }}>
                        <Card className="p-0">
                          <Box className="card-inner-head mb-24">
                            <Typography variant="h3" sx={{ fontWeight: 500 }}>
                              Goals for this SLP
                            </Typography>
                            <Box>
                              <Button variant="outlined" className="px-16">
                                Export
                              </Button>
                            </Box>
                          </Box>
                          Table Here
                        </Card>
                      </Box>
                    </Grid>
                  </Grid>
                </>
              )}
              {activeStep === 2 && (
                <>
                  <Grid container columnSpacing={{ xs: 2, lg: 3, xl: "24px" }}>
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className="gray-text-sm"
                        sx={{ pb: 1 }}
                      >
                        1&#41; Supports: Is there any special help or support
                        you will need to take part in the Recovery and Wellbeing
                        College? How would you like this to be provided?
                      </Typography>
                      <TextField
                        multiline
                        fullWidth
                        variant="outlined"
                        rows={3}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className="gray-text-sm"
                        sx={{ pb: 1 }}
                      >
                        2&#41; Is there anyone else you would like to share this
                        Learning Plan with?
                      </Typography>
                      <TextField
                        multiline
                        fullWidth
                        variant="outlined"
                        rows={3}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className="gray-text-sm"
                        sx={{ pb: 1 }}
                      >
                        3&#41; Positive Outcomes (2nd and subsequent SLPs)
                      </Typography>
                      <TextField
                        multiline
                        fullWidth
                        variant="outlined"
                        rows={3}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DesktopDatePicker"]}>
                          <DesktopDatePicker
                            className="date-picker"
                            label="Date Completed"
                            slotProps={{
                              textField: { fullWidth: true },
                            }}
                            slots={{
                              openPickerIcon: CalendarIcon,
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DesktopDatePicker"]}>
                          <DesktopDatePicker
                            className="date-picker"
                            label="Next SLP Due Date"
                            slotProps={{
                              textField: { fullWidth: true },
                            }}
                            slots={{
                              openPickerIcon: CalendarIcon,
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12}>
                      <Card className="p-0">
                        <Box className="card-inner-head mb-24">
                          <Typography variant="h3" sx={{ fontWeight: 500 }}>
                            Course Preferences
                          </Typography>
                        </Box>
                        Table Here With Checkbox Here
                      </Card>
                    </Grid>
                  </Grid>
                </>
              )}
            </Box>
          </Box>
          <Box className="stepper-btn-group">
            <Button
              disabled={activeStep === 0}
              onClick={handleBack}
              className="btn-prev"
              variant="outlined"
            >
              <img src={prevIcon} alt="Previous" className="active" />
              <img src={prevIconDisabled} alt="Previous" className="disabled" />
              <img src={prevIconLight} alt="Previous" className="hovered" />
              Previous
            </Button>

            <Button
              onClick={handleNext}
              className="btn-next"
              variant="contained"
            >
              {activeStep === steps.length - 1 ? "Submit" : "Next"}
              <img src={nextIcon} alt="Next" />
            </Button>
          </Box>
          <DesignerFooter />
        </div>
      </main>

      {/* Assess Goal Attainment Modal */}
      <Modal open={assess} onClose={handleAssessClose}>
        <Box className="common-modal modal-600">
          <Box className="modal-header">
            <Typography variant="h4">Assess Goal Attainment</Typography>
            <IconButton onClick={handleAssessClose}>
              <img src={closeIcon} alt="close" />
            </IconButton>
          </Box>
          <Box className="modal-body">
            <Grid container columnSpacing="16px">
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DesktopDatePicker"]}>
                    <DesktopDatePicker
                      className="date-picker"
                      label="Date Goal Assessed"
                      slotProps={{
                        textField: { fullWidth: true },
                      }}
                      slots={{
                        openPickerIcon: CalendarIcon,
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth className="select">
                  <InputLabel>Achievement Rating (GAS)*</InputLabel>
                  <Select
                    label="Achievement Rating (GAS)*"
                    value={select1}
                    onChange={handleSelect1Change}
                  >
                    <MenuItem value="Much better 6">Much better 6</MenuItem>
                    <MenuItem value="A little better 5">
                      A little better 5
                    </MenuItem>
                    <MenuItem value="As expected 4">As expected 4</MenuItem>
                    <MenuItem value="Partially achieved 3">
                      Partially achieved 3
                    </MenuItem>
                    <MenuItem value="Same as baseline 2">
                      Same as baseline 2
                    </MenuItem>
                    <MenuItem value="Worse 1">Worse 1</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Variance"
                  multiline
                  className="suggestion-textarea"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Box>
          <Box className="modal-footer">
            <Button
              variant="contained"
              className="btn-save"
              onClick={handleAssessClose}
            >
              <img src={saveIcon} alt="save" />
              Save
            </Button>
            <Button
              variant="outlined"
              className="btn-cancel"
              onClick={handleAssessClose}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default DesignerSLPGoals;
